<template>
  <b-modal
    id="tfa-request"
    ref="modal"
    centered
    hide-header
    hide-footer
    size="sm"
    @shown="$refs.input.focus()"
    @hide="hide"
  >
    <div class="mb-2 text-center">
      <h2 class="mb-0">Enter 2FA code</h2>
      <div>Or use a one time recovery code</div>
    </div>

    <NanInput
      ref="input"
      v-model="code"
      prependIcon="icon-key"
      placeholder="2FA Code"
      aria-label="2FA Code"
      class="mb-2"
      @keyup.enter="submit"
    />
    <div v-if="error" class="small text-danger text-center">
      invalid code, try again
    </div>

    <div class="my-4 text-center">
      If you're having problems,<br />
      contact us at <a href="mailto:support@nanome.ai">support@nanome.ai</a>
    </div>

    <b-button
      :disabled="!code"
      variant="primary"
      type="submit"
      class="px-4"
      block
      @click="submit"
    >
      Submit
    </b-button>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    code: "",
    error: false
  }),

  computed: mapState(["request2FA"]),

  watch: {
    request2FA: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.$refs.modal.hide();
          return;
        }

        // show error if 2FA requested again
        this.error = !!(oldValue && newValue);
        this.code = "";
        this.$refs.modal.show();
      }
    }
  },

  methods: {
    hide() {
      if (!this.request2FA) return;
      this.request2FA.reject();
    },
    submit() {
      if (!this.code) return;
      this.request2FA.resolve(this.code);
    }
  }
};
</script>
